import React, { useEffect, useState } from 'react';
import { Table, message, Modal } from 'antd';
import { Trash2, Edit, Eye, Plus } from 'lucide-react';
import { useParams, useNavigate } from 'react-router-dom';
import { getSoilSolutionAnalysisByExploitation, deleteSoilSolutionAnalysis } from '../../../Utils/analysis/soilSolutionAnalysis';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import Loading from '../../Shared/Loading';

const { confirm } = Modal;


const SoilSolutionAnalysis = () => {
  const { exploitationId } = useParams();
  const navigate = useNavigate();
  const [soilSolution, setSoilSolution] = useState([]);
  const [loading, setLoading] = useState(true);
  const userRole = useSelector((state) => state.user.userRole.name);


  const userLink = () => {
        if (userRole === 'client') {
          return '/client';
        } else if (userRole === 'admin' || userRole === 'superadmin') {
          return '/admin';
        } else if (userRole === 'domain_manager') {
          return '/domain-manager';
        } else if (userRole === 'exploitation_manager') {
          return '/exploitation-manager';
        }
      };
  useEffect(() => {
    fetchSoilSolution();
  }, [exploitationId]);

  const fetchSoilSolution = async () => {
    setLoading(true);
    try {
      const response = await getSoilSolutionAnalysisByExploitation(exploitationId);
      setSoilSolution(response.data);
    } catch (error) {
      console.error('Error fetching soil solution analyses:', error);
      message.error('Failed to fetch soil solution analyses');
    }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    confirm({
      title: 'Êtes-vous sûr de vouloir supprimer cette analyse de solution du sol ?',
      icon: <ExclamationCircleOutlined />,
      content: 'Cette action est irréversible.',
      okText: 'Oui',
      okType: 'danger',
      cancelText: 'Non',
      onOk: async () => {
        try {
          await deleteSoilSolutionAnalysis(id);
          message.success('Analyse de solution du sol supprimée avec succès');
          fetchSoilSolution();
        } catch (error) {
          console.error('Erreur lors de la suppression de l\'analyse de solution du sol:', error);
          message.error('Échec de la suppression de l\'analyse');
        }
      },
    });
  };


  const handleEdit = (record) => {
    navigate(`/admin/exploitation/${exploitationId}/edit-soil-solution/${record.analysis_id}`);
  };

  const handleView = (record) => {
    navigate(`${userLink()}/exploitation/${exploitationId}/view-soil-solution/${record.analysis_id}`);
  };

  const handleCreateAnalysis = () => {
    navigate(`/admin/exploitation/${exploitationId}/create-soil-solution`);
  };

  const columns = [
    { title: 'Echantillon', dataIndex: 'echantillon', key: 'echantillon' },
    { title: 'Date de réalisation', dataIndex: 'date_realisation', key: 'date_realisation', render: (date) => new Date(date).toLocaleDateString() },
    { title: 'Laboratoire', dataIndex: 'laboratoire', key: 'laboratoire' },
    { title: 'Vanne associée', dataIndex: 'vanne_associee', key: 'vanne_associee' },
    { title: 'Type de sol', dataIndex: 'type_sol', key: 'type_sol' },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <span className="flex space-x-2">
          <Eye
            onClick={() => handleView(record)}
            className="text-green-500 cursor-pointer"
          />
          { (userRole === 'admin' || userRole === 'superadmin') &&
            <>
            <Edit
              onClick={() => handleEdit(record)}
              className="text-blue-500 cursor-pointer"
            />
            <Trash2
              onClick={() => handleDelete(record.analysis_id)}
              className="text-red-500 cursor-pointer"
            />
          </>}
        </span>
      ),
    },
  ];
  

  return (
    <div className="w-full">
      {loading && <Loading />}
        <Table
          dataSource={soilSolution}
          columns={columns}
          rowKey="id"
        />
        { (userRole === 'admin' || userRole === 'superadmin') &&
          <button
          className="fixed bottom-10 right-10 bg-blue-500 text-white p-4 rounded-full shadow-lg hover:bg-blue-600 transition duration-300 ease-in-out"
          onClick={handleCreateAnalysis}
        >
          <Plus />
        </button>}
    </div>
  );
};

export default SoilSolutionAnalysis;